// PolitiqueCookies.txt
import React from "react";

const PolitiqueCookies = () => {
  const openCookieManager = () => {
    // ⚠️ À brancher sur ton CMP (Didomi, Axeptio, TarteAuCitron, CookieYes, etc.)
    console.info("Ouvrir le gestionnaire de cookies (CMP) : à connecter.");
  };

  return (
    <div className="legal-page">
      <div className="legal-header">
        <h1>Politique cookies</h1>
        <p>Dernière mise à jour : {LAST_UPDATE}</p>
      </div>

      <section className="legal-section">
        <h2>1. Qu’est-ce qu’un cookie ?</h2>
        <p>
          Un cookie est un petit fichier déposé sur votre terminal lors de la consultation d’un site.
          Il permet notamment de mémoriser des préférences, de sécuriser certaines fonctionnalités,
          et/ou de mesurer l’audience.
        </p>
      </section>

      <section className="legal-section">
        <h2>2. Cookies utilisés</h2>
        <ul>
          <li>
            <strong>Nécessaires</strong> : indispensables au fonctionnement du site (ex. mémorisation du
            choix de consentement).
          </li>
          <li>
            <strong>Mesure d’audience</strong> : Google Analytics (soumis à votre consentement).
          </li>
        </ul>
      </section>

      <section className="legal-section">
        <h2>3. Gestion du consentement</h2>
        <p>Vous pouvez accepter, refuser ou personnaliser les cookies à tout moment.</p>
        <button type="button" onClick={openCookieManager} className="legal-button">
          Gérer mes cookies
        </button>
      </section>

      <section className="legal-section">
        <h2>4. Liste des cookies</h2>
        <p>
          Liste indicative (peut varier selon configuration GA4, Tag Manager, options) :
        </p>

        <div className="legal-tableWrap" role="region" aria-label="Liste des cookies" tabIndex={0}>
          <table className="legal-table">
            <thead>
              <tr>
                <th>Nom</th>
                <th>Finalité</th>
                <th>Durée</th>
                <th>Catégorie</th>
                <th>Fournisseur</th>
              </tr>
            </thead>
            <tbody>
              {COOKIE_ROWS.map((c) => (
                <tr key={c.name}>
                  <td>{c.name}</td>
                  <td>{c.purpose}</td>
                  <td>{c.duration}</td>
                  <td>{c.category}</td>
                  <td>{c.provider}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </section>

      <section className="legal-section">
        <h2>5. Contact</h2>
        <p>
          Pour toute question : <a href={`mailto:${CONTACT_EMAIL}`}>{CONTACT_EMAIL}</a>.
        </p>
      </section>
    </div>
  );
};

const LAST_UPDATE = "2026-02-19";
const CONTACT_EMAIL = "contact@tocreate.fr";

const COOKIE_ROWS = [
  {
    name: "cookie_consent",
    purpose: "Mémoriser votre choix en matière de cookies",
    duration: "6 mois",
    category: "Nécessaire",
    provider: "Site / CMP",
  },
  {
    name: "_ga",
    purpose: "Mesure d’audience (identifiant utilisateur)",
    duration: "13 mois",
    category: "Audience",
    provider: "Google Analytics",
  },
  {
    name: "_ga_*",
    purpose: "Mesure d’audience (persistance session/état)",
    duration: "13 mois",
    category: "Audience",
    provider: "Google Analytics",
  },
];

export default PolitiqueCookies;
